import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_RESPONSE_QUERY = print(gql`
  mutation DeleteFormResponse($id: Int!) {
    deleteFormResponse(id: $id) {
      id
    }
  }
`);

export interface DeleteResponseGql {
  deleteFormResponse: {
    id?: number;
  };
}
